import { useState, useEffect, useRef } from "react"
import { ToastContainer, toast } from "react-toastify"
import axios from "axios"
import "./app.css"
import Tab from "./component/tab"
import BarcodeScanner from "./barcodeScanner"
const API_BASE = "https://mp-audit-service.three-shelves.com"

function App() {
  const [locations, setLocations] = useState([])
  const [saleType, setSaleType] = useState("Box")
  const [location, setLocation] = useState("")
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [barcode, setBarcode] = useState("")
  const [quantity, setQuantity] = useState("")
  const [token, setToken] = useState(localStorage.getItem("token") || "")
  const quantityRef = useRef(null)
  useEffect(() => {
    // Fetch location list on load

    ; (async () => {
      try {
        const response = await axios.get(`${API_BASE}/verify`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        console.log("repsonse", response)
        // setLocations(response.data.locations)
      } catch (error) {
        localStorage.clear()
        setToken("")
        console.error("Error fetching locations:", error)
      }
    })()
    const fetchLocations = async () => {
      try {
        const response = await axios.get(`${API_BASE}/locations`)
        setLocations(response.data.locations)
      } catch (error) {
        console.error("Error fetching locations:", error)
      }
    }

    fetchLocations()
  }, [token])

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${API_BASE}/login`, {
        location,
        username,
        password
      })
      localStorage.setItem("token", response.data.token)
      setToken(response.data.token)
      toast.success("Login successful!")
    } catch (error) {
      console.error("Login error:", error)
      toast.error("Login failed. Check your credentials.")
    }
  }

  useEffect(() => {
    if (barcode && saleType === "Box") {
      handleScan()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barcode, saleType])
  const handleScan = async () => {
    if (!barcode) {
      toast.error("Please enter a barcode.")
      return
    }

    try {
      const response = await axios.post(
        `${API_BASE}/scan`,
        {
          barcode,
          quantity: saleType === "Loose" ? quantity : 1,
          box: saleType === "Box"
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      toast.success(response.data.message)
      setQuantity(1)
      setBarcode("")
    } catch (error) {
      console.error("Scan error:", error)
      toast.error(error.response?.data?.message || "Failed to scan barcode.")
    }
  }

  return (
    <div className="App">
      <h1>Meri Pharmacy Scanner</h1>
      <p style={{ textAlign: "center", marginBottom: "50px" }}>
        Inventory Management
      </p>

      {!token ? (
        <div>
          <h2>Login</h2>
          <select
            style={{
              padding: "5px",
              borderRadius: "5px",
              marginBottom: "10px"
            }}
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          >
            <option value="">Select location</option>
            {locations?.map((b) => (
              <option key={b.id} value={b.location_id}>
                {b.name}
              </option>
            ))}
          </select>
          <br />
          <input
            type="text"
            style={{
              padding: "5px",
              borderRadius: "6px",
              marginBottom: "10px"
            }}
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <br />
          <input
            style={{
              padding: "5px",
              borderRadius: "6px",
              marginBottom: "10px"
            }}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <br />
          <button
            style={{
              padding: "5px 10px",
              borderRadius: "10px"
            }}
            onClick={handleLogin}
          >
            Login
          </button>
        </div>
      ) : (
        <div>
          <h2>Scan Barcode</h2>
          <Tab
            tab={saleType}
            setTab={(val) => {
              setBarcode("")
              setQuantity("")
              setSaleType(val)
            }}
            tabs={["Box", "Loose"]}
          />
          <p>Barcode</p>
          <BarcodeScanner
            barcode={barcode}
            setBarcode={(val) => {
              setBarcode(val)
              quantityRef.current?.focus()
            }}
          />
          <br />
          <br />
          {saleType !== "Box" && (
            <>
              <p>Quantity</p>
              <input
                type="number"
                ref={quantityRef}
                placeholder="Enter Quantity"
                value={quantity}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    // eslint-disable-next-line eqeqeq
                    if (!e.target.value || e.target.value == 0)
                      return toast.warning("Please enter a valid quantity")
                    handleScan()
                  }
                }}
                onChange={(e) => setQuantity(e.target.value)}
                disabled={saleType === "Box"}
                style={{
                  padding: "12px",
                  fontsize: "24px",
                  fontWeight: 600,
                  borderRadius: "6px"
                }}
              />
            </>
          )}
          <br />

          <br />
          {saleType !== "Box" && <button onClick={handleScan}>Submit</button>}

          <button
            style={{
              padding: "8px 16px",
              borderRadius: "5px",
              position: "absolute",
              bottom: "50px",
              right: "50px"
            }}
            onClick={() => {
              localStorage.clear()
              setToken("")
            }}
          >
            Logout
          </button>
        </div>
      )}

      <ToastContainer />
      {/* {message && <p>{message}</p>} */}
    </div>
  )
}

export default App
